var makeSquareInit = function () {
    var rectanglesToSelect = $('[data-id="makeSquare"]');

    var makeSquare = function () {
        width = rectanglesToSelect.css('width');
        rectanglesToSelect.css('height', width);
    }

    makeSquare();

    var delay = (function () {
        var timer = 0;
        return function (callback, ms) {
            clearTimeout(timer);
            timer = setTimeout(callback, ms);
        };
    })();

    $(window).on('resize', function () {
        delay(function () {
            makeSquare();
        }, 500);
    });
};


   

